import { render, staticRenderFns } from "./LiveStreamsList.vue?vue&type=template&id=477f34b0&scoped=true&"
import script from "./LiveStreamsList.vue?vue&type=script&lang=js&"
export * from "./LiveStreamsList.vue?vue&type=script&lang=js&"
import style0 from "./LiveStreamsList.vue?vue&type=style&index=0&id=477f34b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477f34b0",
  null
  
)

export default component.exports